import { jsx, jsxs } from "react/jsx-runtime";
const YoutubeIcon = ({ fill }) => {
  return /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", viewBox: "0 0 36 36", children: /* @__PURE__ */ jsxs("g", { "data-name": "Group 9244", children: [
    /* @__PURE__ */ jsx("g", { "data-name": "Group 9242", children: /* @__PURE__ */ jsx(
      "path",
      {
        "data-name": "Path 13661",
        d: "M18 0a18 18 0 1 0 18 18A18 18 0 0 0 18 0z",
        style: { fill: fill || "#181d56" }
      }
    ) }),
    /* @__PURE__ */ jsx("g", { "data-name": "Group 9243", children: /* @__PURE__ */ jsxs("g", { "data-name": "Youtube", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          "data-name": "Path 15456",
          d: "M20.4 2.292A2.618 2.618 0 0 0 18.557.438C16.932 0 10.417 0 10.417 0S3.9 0 2.277.438A2.617 2.617 0 0 0 .435 2.292 27.466 27.466 0 0 0 0 7.339a27.467 27.467 0 0 0 .435 5.047 2.618 2.618 0 0 0 1.842 1.854c1.625.438 8.14.438 8.14.438s6.515 0 8.14-.438a2.618 2.618 0 0 0 1.843-1.853 27.461 27.461 0 0 0 .435-5.047 27.46 27.46 0 0 0-.435-5.048",
          transform: "translate(7.5 10.654)",
          style: { fill: "#fff" }
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          "data-name": "Path 15457",
          d: "m93.333 54.405 5.827-3.315-5.827-3.315z",
          transform: "translate(-77.329 -33.097)",
          style: { fill: "#181d56" }
        }
      )
    ] }) })
  ] }) });
};
export {
  YoutubeIcon
};
//# sourceMappingURL=footer_youtube.js.map
